import { match, matchPath } from 'react-router'
import { createSelector } from 'reselect'
import {
  AccountMatchParams,
  accountRouteProps,
} from 'src/navigation/routeProps'
import {
  selectCreditCardStatisticsActiveBudgetCountFromState,
  selectCreditCardStatisticsActiveVcnCountFromState,
  selectCreditCardStatisticsBudgetCountFromState,
  selectCreditCardStatisticsVcnCountFromState,
} from 'src/redux/selectors/data/creditCards.selectors'
import { selectCalculatedBackgroundLocation } from 'src/redux/selectors/router.selectors'

export const selectCreditCardIdFromRoute = createSelector(
  [selectCalculatedBackgroundLocation],
  (backgroundLocation) => {
    const mtch = matchPath<AccountMatchParams>(
      backgroundLocation.pathname,
      accountRouteProps,
    ) as match<AccountMatchParams>
    return mtch.params.id
  },
)

export const selectCreditCardStatisticsActiveVcnCount = createSelector(
  [
    selectCreditCardStatisticsActiveVcnCountFromState,
    selectCreditCardIdFromRoute,
  ],
  (activeVcnCount, creditCardId) => {
    return activeVcnCount[creditCardId] !== undefined
      ? activeVcnCount[creditCardId]
      : undefined
  },
)

export const selectCreditCardStatisticsVcnCount = createSelector(
  [selectCreditCardStatisticsVcnCountFromState, selectCreditCardIdFromRoute],
  (vcnCount, creditCardId) => {
    return vcnCount[creditCardId] !== undefined
      ? vcnCount[creditCardId]
      : undefined
  },
)

export const selectCreditCardStatisticsActiveBudgetCount = createSelector(
  [
    selectCreditCardStatisticsActiveBudgetCountFromState,
    selectCreditCardIdFromRoute,
  ],
  (activeBudgetCount, creditCardId) => {
    return activeBudgetCount[creditCardId] !== undefined
      ? activeBudgetCount[creditCardId]
      : undefined
  },
)

export const selectCreditCardStatisticsBudgetCount = createSelector(
  [selectCreditCardStatisticsBudgetCountFromState, selectCreditCardIdFromRoute],
  (budgetCount, creditCardId) => {
    return budgetCount[creditCardId] !== undefined
      ? budgetCount[creditCardId]
      : undefined
  },
)
